export default "assets/images/form-background-0b5f602a.jpg";